import React from "react";
import SideBar from "../SideBar/SideBar";
import "./UsingThePlatform.css";
const UsingThePlatform = () => {
  return (
    <div className="using_the_platform_parent_div">
      <SideBar></SideBar>
      <div className="understanding_content_div">
        <h2 className="understanding_heading">Using The Platform</h2>
        <div className="understanding_text">
          <h4 className="understanding_que">
            1.Can I choose who I connect with on TripShipTask?
          </h4>
          <p className="understanding_ans">
            • Yes, you have the flexibility to choose whom you connect with for
            trips, tasks, or deliveries, based on profiles, reviews, and
            specific service requirements.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            2.Can I schedule services in advance on TripShipTask?
          </h4>
          <p className="understanding_ans">
            • Yes, our platform allows you to schedule rides, deliveries, and
            tasks in advance according to your convenience. In fact, we highly
            encourage users to plan ahead and schedule actions well before the
            scheduled time for a better and safe process completion.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            3.How are payments handled on TripShipTask?
          </h4>
          <p className="understanding_ans">
            • Payments for services on TripShipTask are processed securely
            through the app. You can also transact cash with other users where
            TripShipTask keeps a record of the transaction and you pay the
            platform fee periodically. Users can make E-Payments using various
            debit or credit cards, mobile banking such as BKash, Nagad, UPay,
            Rocket, Upay – all these popular payment methods for seamless
            transactions.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            4.Are there any fees associated with using TripShipTask?
          </h4>
          <p className="understanding_ans">
            • TripShipTask may charge a nominal fee or commission for the
            services facilitated through the platform and for account
            verification, security deposit or cancellation fee. These are
            clearly outlined in Charge Points under QUICK LINKS on the website
            footer. Our terms and other conditions are designed to be
            transparent and user-friendly.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            5.Can I cancel a service on TripShipTask after booking?
          </h4>
          <p className="understanding_ans">
            • Yes, you can cancel a service, though certain conditions and
            potential fees may apply, as detailed in our cancellation policy.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            6.What happens if a task or delivery is not completed as expected?
          </h4>
          <p className="understanding_ans">
            • We have a dispute resolution system in place. Users can report any
            issues through the app ticket system, and our support team will
            assist in resolving them fairly.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            7.Can I request a specific service provider on TripShipTask?
          </h4>
          <p className="understanding_ans">
            • If you had a good experience with a provider, you can request them
            again, subject to their availability.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            8.How do I become a service provider on TripShipTask?
          </h4>
          <p className="understanding_ans">
            • Sign up through the app to browse, complete a quick verification
            process to enjoy full features of the App including posting and
            bidding on posts. There is no separate App, you can use the same app
            to act as a consumer as well as a service provider.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            9.Can I offer multiple services on TripShipTask?
          </h4>
          <p className="understanding_ans">
            • Absolutely! You can list multiple services you're capable of
            offering, from communal travel to various tasks. However, we do not
            encourage you to offer a service unless you are really good at it.
            TripShipTask does not take any responsibility in any accidents or
            mishaps that may take place because of your inexperience in a
            specific matter or area, so use your best judgment to avoid any kind
            of accident/unwanted situation.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            10. Is there an age requirement to use TripShipTask?
          </h4>
          <p className="understanding_ans">
            • Users must be at least 16 years old to register and use the
            services offered by TripShipTask. Under 16 users can use the
            platform with parents’ consent as well as TripShipTask approval
            process.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            11. How can I update my service offerings or availability on
            TripShipTask?
          </h4>
          <p className="understanding_ans">
            • You can easily update your service offerings and availability
            through the app's or website’s user-friendly interface.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            12. Can I pause my service offerings on TripShipTask when I'm not
            available?
          </h4>
          <p className="understanding_ans">
            • Yes, our app allows you to post according to your availability,
            giving you the flexibility to offer services only when you're
            available.
          </p>
        </div>
        <div className="understanding_text">
          <h4 className="understanding_que">
            13. Can I use TripShipTask for emergency services?
          </h4>
          <p className="understanding_ans">
            • While TripShipTask is a versatile platform, it is not intended for
            emergency use. It's designed for scheduled services and should not
            replace emergency professional services.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UsingThePlatform;
